import { useQuery } from "@tanstack/react-query";
import { getReservations } from "../api/reservations";

export default function useReservations() {
  return useQuery({
    queryKey: ["reservations"],
    queryFn: getReservations
  });
}